import {
  Breadcrumb,
  Typography,
  Button,
  Row,
  Col,
  Modal,
  Form,
  Input,
  Checkbox,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import lang from "src/lang";
import DepartmentTable from "./DepartmentTable";
import { useEffect, useRef, useState } from "react";
import apiRequest from "src/common/utils/apiRequest";
import { ActionType } from "@ant-design/pro-components";

import { Department } from "src/modules/setting/user-management/types";

const { Title } = Typography;

const DepartmentComponent = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [activeRow, setActiveRow] = useState<Department | null>(null);
  const [form] = Form.useForm();

  const actionRef = useRef<ActionType>();

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSave = () => {
    form
      .validateFields()
      .catch((err) => {
        message.error(err.errorFields[0].errors[0]);
      })
      .then(async (values) => {
        setSaving(true);

        const ENDPOINT =
          activeRow !== null ? "department/edit" : "department/add";
        const API_REQUEST = new apiRequest(ENDPOINT, true);

        await API_REQUEST.send(
          { ...values, id: activeRow?.id },
          (data: { status: string; message: string; vehicle: string }) => {
            if (data.status === "success") {
              message.success(data.message);
              handleCancel();
              actionRef?.current?.reload();
            } else {
              message.error(data.message);
            }
          }
        );

        setSaving(false);
      });
  };

  useEffect(() => {
    if (activeRow) {
      form.setFieldsValue(activeRow);
    }
  }, [activeRow]);

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: "16px" }} separator=">">
        <Breadcrumb.Item>{lang.get("setting", ["Home"])}</Breadcrumb.Item>
        <Breadcrumb.Item>
          {lang.get("setting", ["User Management"])}
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {lang.get("setting", ["Departments"])}
        </Breadcrumb.Item>
      </Breadcrumb>

      {/* Page Title */}
      <Title level={2} style={{ marginBottom: "16px" }}>
        {lang.get("setting", ["Departments"])}
      </Title>

      {/* Filter and Actions */}
      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: "left" }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleOpenModal}
          >
            {lang.get("setting", ["New Department"])}
          </Button>
        </Col>
      </Row>

      {/* Table */}
      <DepartmentTable
        actionRef={actionRef}
        setActiveRow={setActiveRow}
        openModel={setIsModalVisible}
      />

      <Modal
        title={lang.get("setting", ["New Department"])}
        open={isModalVisible}
        onCancel={handleCancel}
        onClose={handleCancel}
        onOk={handleSave}
        okText={lang.get("setting", ["Save"])}
        cancelText={lang.get("setting", ["Cancel"])}
      >
        <Form form={form} layout="vertical" disabled={saving}>
          {/* Department Name */}
          <Form.Item
            name="name"
            label={<span style={{ fontSize: "14px" }}>Department Name</span>}
            rules={[
              { required: true, message: "Department Name is required!" },
            ]}
          >
            <Input placeholder="Enter Department Name" size="large" />
          </Form.Item>

          {/* Hide from Client */}
          <Form.Item name="hide_from_users" valuePropName="checked">
            <Checkbox>
              <span style={{ fontSize: "14px" }}>Hide from Client?</span>
            </Checkbox>
          </Form.Item>

          {/* Department Email */}
          <Form.Item
            name="email"
            label={<span style={{ fontSize: "14px" }}>Department Email</span>}
            rules={[
              {
                type: "email",
                message: "Please enter a valid email address!",
              },
              {
                required: true,
                message: "Department Email is required!",
              },
            ]}
          >
            <Input placeholder="Enter Department Email" size="large" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default DepartmentComponent;
